module.exports = __webpack_public_path__ + "img/BAT.f61329e0.svg";